import { generatePath } from 'react-router-dom';

import { ROUTES } from '#client/manifest';

import { processMenu } from '../utils/menu';

/**
 * Get the tax services menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: string[]
 *  ldFlags: object
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getTaxServicesMenu({
  businessEntityUuid,
  entitlements,
  ldFlags,
  order
}) {
  const { enableTaxServices } = ldFlags;
  const hasTaxEntitlements = entitlements.has('tax_annual_filing')
    || entitlements.has('tax_unlimited_advice');

  if (!enableTaxServices || !hasTaxEntitlements) {
    return {};
  }

  return processMenu({
    title: 'Tax Advice',
    icon: 'calculator-fill.svg',
    path: generatePath(ROUTES.taxServices, { businessEntityUuid }),
    order
  });
}
